import React, { useState } from 'react';
import { useLayoutEffect } from 'react';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import AjaxErrorBoundary from '../../ajax/errorBoundary';
import ErrorList from '../../errorList';
import { useDataFetcher } from '../../hooks';
import fetchResults from '../runSheet/fetchResults';
import RunSheet from '../runSheet/RunSheet';
import { Answer, IRunSheet } from '../runSheet/types';
import { IModeratorPageRouteParams } from './types';
import updateResults from './updateResults';

const ModeratorPage: React.FC = () => {

    const { id } = useParams<IModeratorPageRouteParams>();

    const [token, setToken] = useState<string>('');
    const [report, setReport] = useState<IRunSheet>({
        runFileId: 0,
        isAssessor: false,
        attendanceConfirmed: false,
        resultsSubmitted: false,
        groups: [],
        runDate: ''
    });

    const [isComplete, setIsComplete] = useState<boolean>(false);
    const [isSaving, setIsSaving] = useState<boolean>(false);
    const [ajaxErrors, setAjaxErrors] = useState<Array<string>>([]);

    const [reportBusy, setReportBusy] = useState<boolean>(false);
    const [isFetchingOverallAssessmentGrades, setIsFetchingOverallAssessmentGrades] = useState<boolean>(false);
    const [reportErrors, setReportErrors] = useState<Array<string>>([]); 

    const { busy, errors, data } = useDataFetcher(
        `/api/runSheet/${id}/moderator`,
    );

    useEffect(() => {
        if (data) {
            setToken(data.token);
            setReport(data.report);
        }

        if (errors) {
            setReportErrors(errors);
        }

        setReportBusy(busy);

    }, [data, errors, busy]);

    useLayoutEffect(() => {
        if (ajaxErrors.length > 0) {
            window.scrollTo(0, 0);
        }
    }, [ajaxErrors]);

    useLayoutEffect(() => {
        if (ajaxErrors.length > 0) {
            window.scrollTo(0, 0);
        }
    }, [ajaxErrors]);

    const handleReportUpdated = (results: Array<Answer>, complete: boolean) => {
        setIsSaving(true);

        updateResults({ id, token, results, complete })
            .then(() => setIsComplete(complete))
            .catch(setAjaxErrors)
            .finally(() => setIsSaving(false));

    };

    const handleFetchingOverallAssessmentGrades = (results: Array<Answer>, complete: boolean) => {
        setIsFetchingOverallAssessmentGrades(true);

        updateResults({ id, token, results, complete })
            .then(response => {
                setIsComplete(complete);

                if (id) {
                    setReportBusy(true);
                    fetchResults(parseInt(id))
                        .then(res => setReport(res.data))
                        .catch(setReportErrors)
                        .finally(() => setReportBusy(false));
                }
            })
            .catch(setAjaxErrors)
            .finally(() => setIsFetchingOverallAssessmentGrades(false));
    };

    return (
        <AjaxErrorBoundary busy={reportBusy} errors={reportErrors} loadingText="Loading">
            {report.groups.length > 0 && (
                <div className="container">
                    <div className="my-4">
                        <h2>Observed Run Sheet</h2>
                        <ErrorList errors={ajaxErrors} />
                        <RunSheet
                            resultsSubmitted={report.resultsSubmitted || isComplete}
                            isCancelled={false}
                            isOwner={true}
                            busy={isSaving}
                            pdfUrl={''}
                            requiresAttention={false}
                            onReportUpdated={handleReportUpdated}
                            handleFetchingOverallAssessmentGrades={handleFetchingOverallAssessmentGrades}
                            fetchingOverallAssessmentGrades={isFetchingOverallAssessmentGrades}
                            groups={report.groups}
                            runDate={report.runDate}
                        />
                    </div>
                </div>     
            )}

        </AjaxErrorBoundary>
    );

};

export default ModeratorPage;

